import { render, staticRenderFns } from "./clientBasketLg.vue?vue&type=template&id=ffc8a180&scoped=true"
import script from "./clientBasketLg.vue?vue&type=script&lang=js"
export * from "./clientBasketLg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc8a180",
  null
  
)

export default component.exports